import { getBuildEnvironment, isTestEnvironment } from '.';

const isLocalDevServer = process.env.REACT_APP_IS_LOCAL_DEV_SERVER;

export const shouldEnableLogRocket = (): boolean => {
    const environment = getBuildEnvironment();

    if (
        environment === 'development' &&
        !isLocalDevServer &&
        !isTestEnvironment
    ) {
        return true;
    }

    return false;
};
